export default "__VITE_ASSET__DOXGvUMw__"